import { render, staticRenderFns } from "./addServe.vue?vue&type=template&id=f4d99dcc&scoped=true&"
import script from "./addServe.vue?vue&type=script&lang=js&"
export * from "./addServe.vue?vue&type=script&lang=js&"
import style0 from "./addServe.vue?vue&type=style&index=0&id=f4d99dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d99dcc",
  null
  
)

export default component.exports